// viewers/TextViewer.tsx
"use client";
import { useEffect, useState } from "react";
import { highlightHTML } from "../highlight/highlight";

export default function TextViewer({
  url, keywords = [],
}: { url: string; keywords?: string[] }) {
  const [text, setText] = useState<string>("");

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(url);
        setText(await res.text());
      } catch { setText("⚠️ Failed to load file."); }
    })();
  }, [url]);

  return (
    <pre
      className="p-3 bg-gray-50 border-black border-[1px] dark:text-black text-sm whitespace-pre-wrap max-h-[78vh] overflow-y-auto"
      dangerouslySetInnerHTML={{ __html: highlightHTML(text, keywords) }}
    />
  );
}
